import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import toast from "react-hot-toast";
import { axiosConfig } from "../../axios/axiosConfig";

const UserInfoModals = ({ open, onClose, user, onUserUpdate }) => {
  const [formData, setFormData] = useState(user || {});
  const [consentChoices, setConsentChoices] = useState([]);
  useEffect(() => {
    const fetchConsentChoices = async () => {
      try {
        const res = await axiosConfig({
          method: "get",
          url: "/user/consent-choices",
        });
        setConsentChoices(res.data.consent_choices || []);
      } catch (err) {
        const errMsg =
          err?.response?.data?.response ||
          err.message ||
          "Failed to load consent choices";
        toast.error(errMsg);
      }
    };
    fetchConsentChoices();
  }, []);

  useEffect(() => {
    if (user) setFormData(user);
  }, [user]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async () => {
    const requiredFields = [
      "username",
      "email",
      "phoneno",
      "user_type",
      "referralcode",
      "is_active",
    ];
    for (let field of requiredFields) {
      if (
        formData[field] === undefined ||
        formData[field] === null ||
        formData[field] === ""
      ) {
        toast.error(`${field.replace("_", " ")} is required`);
        return;
      }
    }

    if (!formData.username || !formData.email || !formData.phoneno) {
      toast.error("Name, Email, and Phone are required");
      return;
    }

    const payload = {
      username: formData.username,
      email: formData.email,
      phoneno: formData.phoneno,
      userid: formData.id,
      consent_status: formData.consent_status,
    };

    if (formData.is_active) {
      payload.is_active = formData.is_active;
      payload.user_type = formData.user_type;
      payload.referralcode = formData.referralcode;
    }

    try {
      await axiosConfig({
        method: "post",
        url: "/user/userprofile",
        data: payload,
      });
      toast.success("User updated successfully");
      onClose();
      if (onUserUpdate) {
        onUserUpdate();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.response ||
          "Failed to update user. Please try again."
      );
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 600,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxHeight: "90vh",
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Edit User Info</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box mt={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                name="username"
                value={formData.username || ""}
                onChange={handleChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                name="email"
                value={formData.email || ""}
                onChange={handleChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Phone"
                name="phoneno"
                value={formData.phoneno || ""}
                onChange={handleChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="User Type"
                name="user_type"
                value={formData.user_type || ""}
                onChange={handleChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Status</InputLabel>
                <Select
                  name="is_active"
                  value={formData.is_active === true ? "true" : "false"}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      is_active: e.target.value === "true",
                    })
                  }
                  label="Status"
                >
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Referral Code"
                name="referralcode"
                value={formData.referralcode || ""}
                onChange={handleChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Consent Status</InputLabel>
                <Select
                  name="consent_status"
                  value={formData.consent_status || ""}
                  onChange={handleChange}
                  label="Consent Status"
                >
                  {consentChoices.map((choice) => (
                    <MenuItem key={choice.key} value={choice.key}>
                      {choice.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                fullWidth
                sx={{ mt: 2 }}
              >
                Save Changes
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default UserInfoModals;
